<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Felhasználó csoportok') }}</h1>

        <div class="flex items-center mb-8">
            <c-control-text class="w-full" class-field="!h-10 !text-lg" class-group="bg-white border pl-2 rounded-none"
                            icon="search"
                            name="search"
                            v-bind:placeholder="__('Keresés')"
                            v-model="s"
                            v-on:keyup="search"
            />

            <c-button class="bg-slate-800 ml-4 shrink-0 text-white"
                      router
                      v-bind:to="{ name : 'users.groups.create' }"
            >
                + {{ __('Új csoport') }}
            </c-button>
        </div>

        <c-data-table responsive-breakpoint="lg"
                      v-bind:data="tableData"
                      v-if="tableData.items.length > 0"
                      v-on:sort-table="sortTable"
        >
            <template v-slot:item.name="{ item }">
                <router-link class="hover:decoration-dotted hover:underline"
                             v-bind:to="{ name: 'users.groups.edit', params: { group: item.values.id } }"
                >
                    <strong class="block text-slate-500 text-sm">{{ item.values.name }}</strong>
                </router-link>
            </template>
            <template v-slot:item.is_active="{ item }">
                <div class="flex items-center justify-center">
                    <c-icon class="h-6 stroke-success w-6" icon="check-circle" v-if="item.values.is_active" />
                    <c-icon class="h-6 stroke-error w-6" icon="x-square" v-else />
                </div>
            </template>
            <template v-slot:item.actions="{ item }">
                <div class="flex flex-col">
                    <router-link class="cursor-pointer flex hover:decoration-dotted hover:underline text-slate-800 text-xs"
                                 v-bind:to="{ name: 'users.groups.edit', params: { group: item.values.id } }"
                    >
                        <c-icon class="h-4 mr-2 stroke-slate-800 w-4" icon="edit-3" />
                        {{ __('Szerkesztés') }}
                    </router-link>
                    <a class="cursor-pointer flex hover:decoration-dotted hover:underline mt-2 text-slate-800 text-xs"
                       v-if="!item.values.is_default"
                       v-on:click="deletedModel = item.values.id"
                    >
                        <c-icon class="h-4 mr-2 stroke-slate-800 w-4" icon="trash-2" />
                        {{ __('Törlés') }}
                    </a>
                </div>
            </template>
        </c-data-table>

        <span class="block font-serif text-center text-2xl" v-else>{{ __('Nincs találat') }}</span>
    </div>

    <c-modal class="md:w-[450px]" v-bind:open="deletedModel !== null" v-bind:title="__('Felhasználó csoport törlése')" v-on:closeModal="deletedModel = null">
        <template v-slot:body>
            <div class="py-5 text-center text-sm">
                {{ __('Biztosan törölni szeretnéd ezt a felhasználó csoportot?') }}
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end w-full">
                <c-button class="bg-slate-100 mr-2 text-slate-800" v-on:click="deletedModel = null">
                    {{ __('Mégsem') }}
                </c-button>

                <c-button class="bg-error text-white" v-on:click="del">
                    {{ __('Törlés') }}
                </c-button>
            </div>
        </template>
    </c-modal>
</template>

<script setup lang="ts">
    import { inject, onMounted, ref } from 'vue';
    import {
        CButton,
        CControlText,
        CDataTable,
        CIcon,
        CModal,
    } from '@teamfurther/cinderblock';
    import debounce from 'debounce';
    import UserGroupRepository from '../../repositories/UserGroupRepository';

    const __ = inject('__');
    const deletedModel = ref(null);
    const s = ref<string>('');
    const sort = ref<string>('name');
    const tableData = ref<object>({
        columnNames: {
            name: __('Megnevezés'),
            is_active: __('Aktív?'),
            actions: __('Műveletek'),
        },
        defaultSort: '+name',
        items: [],
        sortableColumns: ['name'],
    });
    const userGroupRepository = new UserGroupRepository();

    async function del() {
        await userGroupRepository.destroy(deletedModel.value);

        await getGroups();

        deletedModel.value = null;
    }

    async function getGroups() {
        const result = await userGroupRepository.index({
            filters: {
                name : s.value,
            },
            sort: sort.value,
        });

        tableData.value.items = result.map((group) => {
            return { values : group }
        });
    }

    const search = debounce(async () => {
        await getGroups();
    }, 500);

    async function sortTable(sortBy: string) {
        sort.value = sortBy;

        await getGroups();
    }

    onMounted(async () => {
        await getGroups();
    });
</script>
